<template>
  <div id="zones">
    <Title title="Priorización de áreas"
           subtitle="Prioriza el inicio de la ruta dando prioridad a la zona de mayor índice"/>
    <FilterMapModify :open="form.open">
      <ZonesFormPriority
                 ref="zoneForm"
                 slot="form"
                 :polygon="polygon"
                 @addPoligon="addPoligon"
                 @centerMap="centerMap"
                 @submit="receivePolygonTable"
                 @cleanPoly="cleanPolygonMap"
                 @clickSendZone="clickSendZone"
                 @changePoligonState="changeStatePoligon"></ZonesFormPriority>
      <el-button slot="button"
                 class="btn primary"
                 @click="form.open = !form.open">
        <i v-if="form.open" class="fas fa-angle-left"></i>
        <i v-else class="fa fa-plus"></i>
      </el-button>
      <MapZonesModify ref="map" slot="map"
                @submit="receivePolygon"
                @getPolygonPath="getPolygonPath"></MapZonesModify>
    </FilterMapModify>
  </div>
</template>

<script>
import Title from '../components/base/Title.vue';
import FilterMapModify from '../components/maps/FilterMapModify.vue';
import MapZonesModify from '../components/maps/MapZonesModify.vue';
import ZonesFormPriority from '../components/ZonesFormPriority.vue';

export default {
  name: 'ZonesPriority',
  components: {
    Title,
    FilterMapModify,
    MapZonesModify,
    ZonesFormPriority,
  },
  data() {
    return {
      form: {
        open: true,
        type: '',
      },
      polygon: '',
    };
  },
  methods: {
    receivePolygonTable(data) {
      this.$refs.map.updatePath(data);
    },
    receivePolygon(data) {
      this.polygon = data;
    },
    addPoligon(edit) {
      this.$refs.map.newPath(edit);
    },
    changeStatePoligon(editable) {
      this.$refs.map.changeStatePoligon(editable);
    },
    cleanPolygonMap() {
      this.$refs.map.deleteSelectedShape();
    },
    centerMap(lng, lat, zoom) {
      this.$refs.map.centerMap(lng, lat, zoom);
    },
    clickSendZone() {
      this.$refs.map.getPolygonPath();
    },
    getPolygonPath(data) {
      this.polygon = data;
      this.$refs.zoneForm.sendZone(data);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
